import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InvestigationModel } from '../../models/InvestigationModel'


export interface InvestigationState {
    Investigation: InvestigationModel
    InvestigationList: InvestigationModel[]
}

const initialState: InvestigationState = {
    Investigation: {} as InvestigationModel,
    InvestigationList: [],
}

export const InvestigationSlice = createSlice({
    name: 'investigation',
    initialState,
    reducers: {
        setInvestigation: (state, action: PayloadAction<InvestigationModel[]>) => {
            state.InvestigationList = action.payload
        },
        saveInvestigation: (state, action: PayloadAction<InvestigationModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: InvestigationModel = { Id: 0, InvestigationName: room.InvestigationName, Unit: room.Unit, Rate: room.Rate }
                let currentRoom =
                    state.InvestigationList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.InvestigationName = room.InvestigationName
                    currentRoom.Unit = room.Unit
                     currentRoom.Rate= room.Rate
            } else {
                room.Id = (Math.max(...state.InvestigationList.map((c) => c.Id)) || 0) + 1
                state.InvestigationList.push(room)
            }
        },
        getInvestigationById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let Investigation: InvestigationModel = {} as InvestigationModel
            if (id > 0) {
                let currentInvestigation: InvestigationModel[] = state.InvestigationList
                Investigation = currentInvestigation.find((c) => c.Id === id) || ({} as InvestigationModel)
            }

            state.Investigation = Investigation
        },
        deleteInvestigation: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentInvestigation: InvestigationModel[] = state.InvestigationList
                state.InvestigationList = currentInvestigation.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setInvestigation, saveInvestigation, getInvestigationById, deleteInvestigation } =
InvestigationSlice.actions

export default InvestigationSlice.reducer
